import { render, staticRenderFns } from "./CargoCrudStatusWaitingDocuments.vue?vue&type=template&id=94d3a218"
import script from "./CargoCrudStatusWaitingDocuments.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusWaitingDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports